import { DevTools, Tolgee, FormatSimple } from "@tolgee/web";

export const ALL_LANGUAGES = ["ru", "en", "kz"];
export const DEFAULT_LANGUAGE = "ru";

/**
 * Creates base Tolgee instance with common configuration
 * - DevTools enabled only in development
 * - API credentials from environment variables
 */
export function TolgeeBase() {
  const tolgee = Tolgee().use(FormatSimple());

  // Enable DevTools only in development
  if (process.env.NODE_ENV === "development") {
    tolgee.use(DevTools());
  }

  return tolgee.updateDefaults({
    apiKey: process.env.NEXT_PUBLIC_TOLGEE_API_KEY,
    apiUrl: process.env.NEXT_PUBLIC_TOLGEE_API_URL,
  });
}
